import { render, staticRenderFns } from "./confirm-email.vue?vue&type=template&id=22be0346"
import script from "./confirm-email.ts?vue&type=script&lang=js&external"
export * from "./confirm-email.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports